module.exports = __webpack_public_path__ + "static/media/Ley_27130.c45cb013.pdf";